import { Chip, Grid, styled } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

const ArrayChip = ({ list, max = 4, fontSize, ...props }) => {
  const userState = useSelector(state => state?.userState);
  const theme = userState?.publisher?.theme_color;
  const [showMore, setShowMore] = useState(false);
  if (!list || list?.length === 0) {
    return "-";
  } else {
    const maxList = list?.slice(0, max);
    const restList = list?.length > max;
    const rest = list?.slice(max - 1);
    return (
      <Grid container columnSpacing={1} rowSpacing={1}>
        {(showMore ? list : maxList).map((item, index) => (
          <Grid item key={index} {...props}>
            <ItemChip
              label={item?.name || item || "-"}
              size="small"
              backgroundColor={item?.color}
              variant="outlined"
              className={item?.className || ""}
              fontSize={fontSize}
            />
          </Grid>
        ))}
        {restList && !showMore && (
          <Grid item {...props}>
            <ItemChipMoreShowLess
              label={`+${rest.length - 1}`}
              onClick={() => setShowMore(true)}
              size="small"
              fontSize={fontSize}
              backgroundColor={theme}
            />
          </Grid>
        )}
        {showMore && (
          <Grid item {...props}>
            <ItemChipMoreShowLess
              label="Show Less"
              onClick={() => setShowMore(false)}
              size="small"
              fontSize={fontSize}
              backgroundColor={theme}
            />
          </Grid>
        )}
      </Grid>
    );
  }
};
const ItemChip = styled(Chip, {
  shouldForwardProp: prop => prop !== "fontSize" && prop !== "backgroundColor",
})(({ backgroundColor, fontSize = 13 }) => {
  const fs = parseFloat(fontSize);

  return {
    backgroundColor: backgroundColor === "#FFF" ? "#6b7280" : backgroundColor,
    height: fs + 10,
    borderRadius: (fs + 10) / 2,
    "& .MuiChip-label": {
      fontSize: fs,
      lineHeight: 1,
      paddingLeft: Math.max(6, fs * 0.6),
      paddingRight: Math.max(6, fs * 0.6),
      paddingTop: 0,
      paddingBottom: 0,
    },
  };
});

const ItemChipMoreShowLess = styled(Chip, {
  shouldForwardProp: prop => prop !== "fontSize" && prop !== "backgroundColor",
})(({ backgroundColor, fontSize = 13 }) => {
  const fs = parseFloat(fontSize);
  return {
    color: "#fff",
    backgroundColor: backgroundColor || "#222424",

    height: fs + 10,
    borderRadius: (fs + 10) / 2,
    "& .MuiChip-label": {
      fontSize: fs,
      lineHeight: 1,
      paddingLeft: Math.max(6, fs * 0.6),
      paddingRight: Math.max(6, fs * 0.6),
    },
    "&:hover": {
      color: "black",
      border: "1px solid black",
    },
  };
});
export default ArrayChip;
